import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import api from './http/api'
const { body } = document

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        config: {}, //用户所有权限
        msgType: {}, //用户留言类型
    },
    mutations: {

        //设置用户所有权限
        SET_CONFIG: (state, config) => {
            state.config = config
        },
        //设置用户留言类型
        SET_MSGTYPE: (state, msgType) => {
            state.msgType = msgType
        },
    },
    actions: {
        //主页面自适应类

    },
    getters: {
        config(state) {
            return state.config
        },
        msgType(state) {
            return state.msgType
        },
    }

})
